
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8d98aa","data-name":"vuesax/twotone/notification-bing"}},[_c('path',{attrs:{"d":"M10 19.08a3.431 3.431 0 01-2.407-1 3.431 3.431 0 01-1.003-2.41h1.25a2.169 2.169 0 00.636 1.521 2.169 2.169 0 001.521.636 2.159 2.159 0 002.16-2.157h1.253A3.414 3.414 0 0110 19.08z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10 8.775a.627.627 0 01-.627-.627V5.365A.627.627 0 0110 4.738a.627.627 0 01.623.627v2.783a.627.627 0 01-.623.627z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.016 1.045a6.2 6.2 0 016.179 6.192v1.758a3.811 3.811 0 00.435 1.582l1.059 1.774a2.485 2.485 0 01-1.338 3.633 19.952 19.952 0 01-6.335 1.028 19.951 19.951 0 01-6.33-1.029 2.459 2.459 0 01-1.58-1.471 2.518 2.518 0 01.241-2.161l1.063-1.774a3.746 3.746 0 00.436-1.582V7.239a6.189 6.189 0 016.17-6.194zm0 14.713a18.709 18.709 0 005.941-.963 1.218 1.218 0 00.759-.739 1.233 1.233 0 00-.1-1.063l-1.056-1.771a5.022 5.022 0 01-.614-2.227V7.239a4.926 4.926 0 10-9.851 0v1.756a4.942 4.942 0 01-.614 2.23l-1.057 1.77a1.253 1.253 0 00-.143 1.08 1.233 1.233 0 00.8.719 18.709 18.709 0 005.935.964z"}})])])
          )
        }
      }
    